import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../assets/js/LanguageContext';
import LoginForm from './Login';
import SignUpForm from './SignUp';
import Footer from '../Footer';
import '../../assets/styles/SectionBand.css';
import '../../assets/styles/AuthPage.css';

const AuthPanel = ({ side, active, title, text, cta, onSwitch }) => (
  <div
    className={`tp-auth__panel tp-auth__panel--${side}`}
    aria-hidden={!active}
    inert={active ? undefined : ''}
  >
    <div className="tp-auth__panel-content">
      <h2 className="tp-auth__panel-title">{title}</h2>
      <p className="tp-auth__panel-text">{text}</p>
      <button type="button" className="tp-auth__switch" onClick={onSwitch}>
        {cta}
      </button>
    </div>
  </div>
);

const AuthSwitch = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const isSignup = location.pathname === '/sign-up';

  return (
    <div className="brand-page-stack auth-page">
      <section className="section-band">
        <div className="section-band__inner">
          <h1 className="tp-sr-only">{t(isSignup ? 'signup_title' : 'login_title')}</h1>

          <div className={`tp-auth ${isSignup ? 'is-signup' : ''}`.trim()}>
            <div className="tp-auth__forms">
              <div
                className={`tp-auth__form ${isSignup ? '' : 'is-active'}`.trim()}
                aria-hidden={isSignup}
                inert={isSignup ? '' : undefined}
              >
                <LoginForm />
              </div>
              <div
                className={`tp-auth__form ${isSignup ? 'is-active' : ''}`.trim()}
                aria-hidden={!isSignup}
                inert={isSignup ? undefined : ''}
              >
                <SignUpForm />
              </div>
            </div>

            <div className="tp-auth__panels">
              <AuthPanel
                side="left"
                active={!isSignup}
                title={t('auth_panel_new_title')}
                text={t('signup_lead')}
                cta={t('signup_title')}
                onSwitch={() => navigate('/sign-up')}
              />
              <AuthPanel
                side="right"
                active={isSignup}
                title={t('auth_panel_member_title')}
                text={t('login_lead')}
                cta={t('login_title')}
                onSwitch={() => navigate('/login')}
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AuthSwitch;
